import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { queryFunction, queryKey } from './query';
import { SelectedFilters } from '@/components/FilterData/types';
import { UUID } from '@/api/generatedApi';

export const useFetchAssetCompositeSearch = ({
  assetId,
  tenantId,
  searchQuery,
  selectedFilters,
  onError,
  enabled = true,
}: {
  assetId: UUID;
  tenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  onError?: (error: Error) => void;
  enabled?: boolean;
}) => {
  return useDataGridFetcher({
    queryKey: parameters =>
      queryKey({
        assetId,
        tenantId,
        searchQuery,
        selectedFilters,
        ...parameters,
      }),
    queryFn: parameters =>
      queryFunction({
        assetId,
        tenantId,
        searchQuery,
        selectedFilters,
        ...parameters,
      }),
    onError,
    enabled,
  });
};
